import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';
import { CurrencyFormat } from '../../waitingnotes.component';

export interface PartageDialogData {
  totalAmount: number;
  currencyFormat: CurrencyFormat;
}

@Component({
  selector: 'app-partage-dialog',
  templateUrl: './partage-dialog.component.html',
  styleUrls: ['./partage-dialog.component.css']
})
export class PartageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PartageDialogComponent>,
    public cssService: CssService,
    @Inject(MAT_DIALOG_DATA) public data: PartageDialogData
  ) { }

  numberOfPeople = 2;
  paidFor = 1;
  isClosing = false;
  selectedAmount: number | null = null;

  decreasePaidFor(): void {
    if (this.paidFor > 1)
      this.paidFor--;
  }

  increasePaidFor(): void {
    if (this.paidFor < this.numberOfPeople)
      this.paidFor++;
  }

  increasePeople(): void {
    this.numberOfPeople++;
  }

  decreasePeople(): void {
    if (this.numberOfPeople > 2) {
      this.numberOfPeople--;
      if (this.paidFor > this.numberOfPeople)
        this.paidFor--;
    }
  }

  onConfirm(finalAmount: number): void {
    this.selectedAmount = finalAmount;
    this.isClosing = true;
  }

  onCancel(): void {
    this.selectedAmount = null;
    this.isClosing = true;
  }

  onAnimationEnd() {
    if (this.isClosing)
      this.dialogRef.close(this.selectedAmount);
  }
}
